import { render, staticRenderFns } from "./TaskItemDealPopup.vue?vue&type=template&id=9205275e&scoped=true&"
import script from "./TaskItemDealPopup.vue?vue&type=script&lang=js&"
export * from "./TaskItemDealPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9205275e",
  null
  
)

export default component.exports